<template>
    <div class="paging">
        <a class="paging__nav paging__nav--prev"
           v-bind:class="{ 'is-disabled' : current == 1 }"
           v-if="lastPage > 1"
           v-on:click="updateParentPaging(current - 1)"
        >
            &lsaquo;
        </a>
        <a class="paging__nav paging__nav--next"
           v-bind:class="{ 'is-disabled' : current == lastPage }"
           v-if="lastPage > 1"
           v-on:click="updateParentPaging(current + 1)"
        >
            &rsaquo;
        </a>

        <span class="paging__text" v-if="total > 0">{{ from }} - {{ to }}<span class="is-hidden-mobile"> of {{ total }}</span></span>

        <select class="form__control"
                v-if="total > 0"
                v-model="perPage"
                v-on:change="updateParentPaging(1)"
        >
            <option value="0">All</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
        </select>
    </div>
</template>

<script>
    export default {
        computed: {
            current: function () {
                return this.paging.current
            },
            from: function () {
                return this.paging.from
            },
            lastPage: function () {
                return this.paging.lastPage
            },
            to: function () {
                return this.paging.to
            },
            total: function () {
                return this.paging.total
            }
        },
        data: function() {
            return {
                perPage: this.paging.perPage
            }
        },
        methods: {
            updateParentPaging: function (newPage = null) {
                this.$parent.updatePaging(newPage, this.perPage);
            }
        },
        props: {
            paging: {
                required: true,
                type: Object
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/Paging.vue